import { defineStore } from "pinia";
import { mande } from "mande";

interface Page {
    id: number;
    slug: string;
    title: string;
    route_name: string;
    relative_url: string;
    show_in_header: boolean;
    show_in_footer: boolean;
    order: string;
}

interface Navigation {
    header: {
        sticky: boolean;
        job_count: number;
    };
    slideout: {
        visible: boolean;
    };
}

const api = mande("/api");

export const useAppStore = defineStore("app", {
    state: () => {
        return {
            pages: [],
            navigation: {
                header: {
                    sticky: false,
                    job_count: JOBS_AMOUNT ? JOBS_AMOUNT : 0,
                },
                slideout: {
                    visible: false,
                },
            },
        } as { pages: Page[]; navigation: Navigation };
    },

    actions: {
        async indexPages() {
            const pages = await api.get("pages");

            this.pages = pages as unknown as Page[];

            return Promise.resolve(this.pages);
        },
    },
});
